import {collection, doc, getDocs, deleteDoc, updateDoc, addDoc, query, orderBy, limit, where} from "firebase/firestore";
import {db} from "../firebase";

const libraryPath = "lubi";
const activityPath = "activity";
const usersPath = "users";

export class firebaseService {

    // === USER === //
    static async addUser(user) {
        try {
            const docRef = await addDoc(collection(db, usersPath), {
                name: user.name,
                email: user.email,
                avatarURL: user.picture,
                following: [],
                memberSince: new Date(),
                lastOnline: new Date(),
                privateAccount: false,
            });
            console.log("Document written with ID: ", docRef.id);
        } catch (e) {
            console.error("Error adding document: ", e);
        }
    }

    static async getUserDetails(user) {
        let data = [];

        let userEmail = user.email;
        if (user.userEmail) {
            userEmail = user.userEmail;
        }

        await getDocs(collection(db, usersPath))
            .then((querySnapshot) => {
                data = querySnapshot.docs.map((doc) => ({...doc.data(), id: doc.id}))
                data = data.filter((person) => person.email === userEmail);
            })

        if (data.length > 0) {
            data = data[0];
        }

        return data;
    }

    static async updateUser(user, data) {
        await updateDoc(doc(db, usersPath, user.id), data).then(() => {
            console.log("Document successfully updated!");
        }).catch((error) => {
            console.error("Error updating document: ", error);
        });
    }

    static async deleteUser(user) {
        await deleteDoc(doc(db, usersPath, user.id)).then(() => {
            console.log("Document successfully deleted!");
        }).catch((error) => {
            console.error("Error removing document: ", error);
        });
    }

    static async searchUsersByEmail(email, auth0User, exact = false) {
        let data = [];

        const ref = collection(db, usersPath);
        const q = query(ref, where("privateAccount", "==", false));

        await getDocs(q)
            .then((querySnapshot) => {
                data = querySnapshot.docs.map((doc) => ({...doc.data(), id: doc.id}))
                if (exact) {
                    data = data.filter((person) => person.email.toLowerCase() === email.toLowerCase());
                } else {
                    data = data.filter((person) => person.email.toLowerCase().includes(email.toLowerCase()));
                    data = data.filter((person) => person.email.toLowerCase() !== auth0User.email.toLowerCase());
                }
            })
        return data;
    }

    static async searchUsersByName(name, auth0User) {
        let data = [];
        await getDocs(collection(db, usersPath))
            .then((querySnapshot) => {
                data = querySnapshot.docs.map((doc) => ({...doc.data(), id: doc.id}))
                data = data.filter((person) => person.name.toLowerCase().includes(name.toLowerCase()));

                data = data.filter((person) => person.email.toLowerCase() !== auth0User.email.toLowerCase());
            })
        return data;
    }

    static async isUserOnline(person) {
        const user = await this.getUserDetails(person);

        if (user.length === 0) {
            return false;
        }

        let lastOnline = user.lastOnline.toDate();
        let now = new Date();
        let diff = now.getTime() - lastOnline.getTime();

        let diffMinutes = Math.round(diff / 60000);

        return diffMinutes <= 5;
    }


    // === LUBI LIBRARY === //
    static async getUserLibrary(user) {
        let newData = [];
        await getDocs(collection(db, libraryPath))
            .then((querySnapshot) => {
                newData = querySnapshot.docs.map((doc) => ({...doc.data(), id: doc.id}))
                newData = newData.filter((person) => person.email === user.email);
            })
        return newData;
    }

    static async addBook(book, user, coverBase64, completed = false) {
        let dateCompleted = null;
        if (completed) {
            dateCompleted = new Date();
        }
        try {
            const docRef = await addDoc(collection(db, libraryPath), {
                book: book,
                email: user.email,
                completed: completed,
                dateCompleted: dateCompleted,
                currentlyReading: false,
                rating: 0,
                notes: "",
                dateAdded: new Date(),
                coverData: coverBase64
            });
            console.log("Document written with ID: ", docRef.id);
        } catch (e) {
            console.error("Error adding document: ", e);
        }
    }

    static async deleteBook(id) {
        await deleteDoc(doc(db, libraryPath, id)).then(() => {
            console.log("Document successfully deleted!");
        }).catch((error) => {
            console.error("Error removing document: ", error);
        });
    }

    static async updateBook(id, data) {
        await updateDoc(doc(db, libraryPath, id), data).then(() => {
            console.log("Document successfully updated!");
        }).catch((error) => {
            console.error("Error updating document: ", error);
        });
    }


    // === ACTIVITY === //
    static async getActivities(userDetails) {
        let activities = [];

        const activityRef = collection(db, activityPath);
        const q = query(activityRef, orderBy("activityDate", "desc"), limit(30));

        await getDocs(q)
            .then((querySnapshot) => {
                activities = querySnapshot.docs.map((doc) => ({...doc.data(), id: doc.id}))

                if (userDetails.following?.length > 0) {
                    let following = userDetails.following;
                    let followingEmails = [];
                    following.forEach((dataString) => {
                        let object = JSON.parse(dataString);
                        followingEmails.push(object.email);
                    });
                    activities = activities.filter((activity) => (followingEmails.includes(activity.userEmail)) || activity.userEmail === userDetails.email)
                } else {
                    activities = activities.filter((activity) => activity.userEmail === userDetails.email);
                }
            })

        return activities;
    }

    static async addActivity(user, book, detail, rating = null) {
        try {
            const docRef = await addDoc(collection(db, activityPath), {
                userName: user.name,
                userEmail: user.email,
                userAvatarURL: user.picture,
                bookTitle: book.book.title,
                bookAuthor: this.getAuthors(book.book.author_name),
                bookCoverData: book.coverData,
                activityDetail: detail,
                activityDate: new Date(),
                rating: (rating) ? rating : '0',
            });
            console.log("Document written with ID: ", docRef.id);
        } catch (e) {
            console.error("Error adding document: ", e);
        }
    }

    static async deleteActivity(id) {
        await deleteDoc(doc(db, activityPath, id)).then(() => {
            console.log("Document successfully deleted!");
        }).catch((error) => {
            console.error("Error removing document: ", error);
        });
    }

    static getAuthors = (authors) => {
        if (authors) {
            return authors.join(", ");
        }
        return "Unknown";
    }

}